<div class="path-detail-dialog">
  <header class="path-detail-dialog__hero">
    <div class="path-detail-dialog__hero-text">
      <span class="path-detail-dialog__monogram" aria-hidden="true">{{
        path.name | slice : 0 : 3
      }}</span>
      <div>
        <h2 class="path-detail-dialog__title">{{ path.name }}</h2>
        @if (path.full_name && path.full_name !== path.name) {
        <p class="path-detail-dialog__subtitle">{{ path.full_name }}</p>
        }
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="path-detail-dialog__close"
      aria-label="Luk"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <mat-dialog-content class="path-detail-dialog-content">
    <section class="path-detail-dialog__summary" aria-label="Overblik">
      @if (host.pathRequiresMaintenance(path)) {
      <div class="summary-card summary-card--maintenance">
        <div class="summary-card__head">
          <mat-icon aria-hidden="true">schedule</mat-icon>
          <span>Vedligeholdelse</span>
        </div>
        <p class="summary-card__value">
          {{
            host.getMaintenanceCompletedMinutesDisplayed(path) / 60
              | number : '1.0-1'
          }}
          /
          {{ path.maintenance_minutes_required / 60 | number : '1.0-1' }} t
        </p>
        <div
          class="segmented-bar"
          [matTooltip]="host.getMaintenanceBarTooltip(path)"
          matTooltipClass="duna-maintenance-bar-tooltip"
        >
          <div
            class="bar-fill completed"
            [style.width.%]="host.getMaintenanceProgressPercentage(path)"
          ></div>
          <div
            class="bar-fill intended"
            [style.width.%]="host.getMaintenanceRegisteredBarExtraPercentage(path)"
          ></div>
        </div>
        <div class="summary-card__legend">
          <span><i class="dot dot--completed"></i> Deltaget</span>
          <span><i class="dot dot--intended"></i> Tilmeldt</span>
        </div>
      </div>
      }

      <div class="summary-card">
        <div class="summary-card__head">
          <mat-icon aria-hidden="true">verified</mat-icon>
          <span>DUNA ({{ host.getDunaStatusPeriodLabel(path) }})</span>
        </div>
        <app-duna-validation-badge
          [status]="host.getDunaValidationStatus(path)"
          [isDetailBadge]="true"
          [customTooltip]="
            host.getDunaValidationTooltip(host.getDunaValidationStatus(path), path)
          "
        ></app-duna-validation-badge>
      </div>

      @if (host.pathRequiresMaintenance(path)) {
      <div class="summary-card">
        <div class="summary-card__head">
          <mat-icon aria-hidden="true">flag</mat-icon>
          <span>{{ host.getProfileStatusScopeLabel(path) }}</span>
        </div>
        @if (!host.hasMeritForCurrentPeriod(path)) {
        <span
          class="current-year-badge detail-badge"
          [ngClass]="host.getCurrentYearStatus(path)"
        >
          {{
            host.getCurrentYearStatusText(host.getCurrentYearStatus(path), path)
          }}
        </span>
        } @else {
        <span class="merit-badge detail-badge">Merit</span>
        }
      </div>
      }
    </section>

    @if (
      host.showMaintenanceManualExtras(path) &&
      host.pathRequiresMaintenance(path) &&
      (host.getMaintenanceManualMinutes(path) > 0 ||
        host.getMaintenanceManualAcquireAll(path))
    ) {
    <div class="path-detail-dialog__notice">
      <mat-icon>edit_note</mat-icon>
      <div>
        <strong>Manuel vedligeholdelse (år {{ host.getProfileYear() }})</strong>
        @if (host.getMaintenanceManualMinutes(path) > 0) {
        <p>{{ host.getMaintenanceManualMinutes(path) }} min. registreret manuelt</p>
        }
        @if (host.getMaintenanceManualAcquireAll(path)) {
        <p>Krav opfyldt via manuel markering for det valgte år</p>
        }
      </div>
    </div>
    }

    @if (
      host.getRequiredModules(path).length > 0 ||
      host.getOptionalModules(path).length > 0
    ) {
    <section class="path-detail-dialog__section">
      <div class="section-head">
        <h3>Moduler</h3>
        <div class="module-legend" aria-label="Forklaring af modulstatus">
          <span class="module-legend__item module-legend__item--completed">
            <mat-icon>check_circle</mat-icon> Deltaget
          </span>
          <span class="module-legend__item module-legend__item--enrolled">
            <mat-icon>event_available</mat-icon> Tilmeldt
          </span>
          <span class="module-legend__item module-legend__item--missing">
            <mat-icon>radio_button_unchecked</mat-icon> Ikke tilmeldt
          </span>
        </div>
      </div>

      @if (host.getRequiredModules(path).length > 0) {
      <h4 class="module-group-title">Påkrævede</h4>
      <ul class="module-grid">
        @for (module of host.getRequiredModules(path); track module.id) {
        <ng-container
          *ngTemplateOutlet="moduleCard; context: { $implicit: module }"
        ></ng-container>
        }
      </ul>
      }

      @if (host.getOptionalModules(path).length > 0) {
      <h4 class="module-group-title">Valgfrie</h4>
      <ul class="module-grid">
        @for (module of host.getOptionalModules(path); track module.id) {
        <ng-container
          *ngTemplateOutlet="moduleCard; context: { $implicit: module }"
        ></ng-container>
        }
      </ul>
      } @else if (host.getRequiredModules(path).length === 0) {
      <p class="empty-hint">Ingen valgfrie moduler på denne vej</p>
      }
    </section>
    }

    <ng-template #moduleCard let-module>
      <li class="module-card" [ngClass]="moduleCardClasses(module)">
        <span class="module-card__status-chip">
          <mat-icon>{{ moduleStatusIcon(module) }}</mat-icon>
          {{ moduleStatusLabel(module) }}
        </span>
        <p class="module-card__name">{{ module.name }}</p>
        @if (host.showModuleEventDate(module)) {
        <p
          class="module-card__meta"
          [matTooltip]="host.getModuleEventDateTooltip(module)"
        >
          {{ host.getModuleEventDateLabel(module) }}:
          {{ host.getModuleEventDate(module) | date : 'd. MMM yyyy' }}
        </p>
        }
        <div class="module-card__footer">
          <p class="module-card__meta module-card__meta--maintenance">
            <mat-icon aria-hidden="true">schedule</mat-icon>
            <span>{{ host.getModuleMaintenanceCreditText(module) }}</span>
          </p>
          @if (host.hasModuleDetailPanel(path, module)) {
          <button
            type="button"
            class="module-card__toggle"
            (click)="toggleModuleExpand(module.id, $event)"
          >
            {{
              isModuleExpanded(module.id) ? 'Skjul detaljer' : 'Vis detaljer'
            }}
            <mat-icon>{{
              isModuleExpanded(module.id) ? 'expand_less' : 'expand_more'
            }}</mat-icon>
          </button>
          }
        </div>
        @if (
          host.hasModuleDetailPanel(path, module) && isModuleExpanded(module.id)
        ) {
        <div class="module-card__details">
          @if (host.getModuleDescription(module); as moduleDesc) {
          @if (moduleDesc.trim()) {
          <p class="module-card__description">{{ moduleDesc }}</p>
          }
          }
          @if (host.getModuleCalendarModuleId(path, module); as calendarModuleId) {
          <a
            class="module-card__calendar-link"
            [routerLink]="['/events']"
            [queryParams]="moduleCalendarQueryParams(calendarModuleId)"
            (click)="close()"
          >
            <mat-icon aria-hidden="true">event</mat-icon>
            Søg efter modul i kalenderen
          </a>
          }
        </div>
        }
      </li>
    </ng-template>

    @if (host.getPathParticipationEvents(path).length > 0) {
    <section class="path-detail-dialog__section">
      <div class="section-head">
        <h3>Events</h3>
        <span class="section-head__count"
          >{{ host.getPathParticipationEvents(path).length }} i perioden</span
        >
      </div>
      <ul class="event-list">
        @for (event of host.getPathParticipationEvents(path); track event.uuid) {
        <li>
          <a
            class="event-card"
            [routerLink]="['/event', event.uuid]"
            (click)="close()"
          >
            <div class="event-card__date" aria-hidden="true">
              <span class="event-card__day">{{
                event.date | date : 'd'
              }}</span>
              <span class="event-card__month">{{
                event.date | date : 'MMM yyyy'
              }}</span>
            </div>
            <div class="event-card__body">
              <span class="event-card__title">{{ event.name }}</span>
              @if (
                host.getParticipationEventPathModules(path, event);
                as eventModules
              ) {
                @if (eventModules.length > 0) {
                <ul
                  class="event-card__modules"
                  aria-label="Moduler du opnår på denne uddannelsesvej ved deltagelse"
                >
                  @for (mod of eventModules; track mod.name) {
                  <li class="event-card__module">
                    <mat-icon aria-hidden="true">school</mat-icon>
                    <span>{{ mod.name }}</span>
                    @if (mod.minutes > 0) {
                    <span class="event-card__module-minutes">
                      {{ mod.minutes / 60 | number : '1.0-1' }} t
                    </span>
                    }
                  </li>
                  }
                </ul>
                @if (host.getParticipationEventCreditTooltip(path, event); as overlapTip) {
                <p class="event-card__overlap-hint">{{ overlapTip }}</p>
                }
                }
              }
              <span
                class="event-card__chip"
                [ngClass]="eventStatusClass(event)"
              >
                {{ eventStatusLabel(event) }}
              </span>
            </div>
            <mat-icon class="event-card__chevron">chevron_right</mat-icon>
          </a>
        </li>
        }
      </ul>
    </section>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="path-detail-dialog__actions">
    <button mat-flat-button color="primary" type="button" (click)="close()">
      Luk
    </button>
  </mat-dialog-actions>
</div>
